<template>
  <div class="moduleEdit">
    <v-breadcrumbs>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
        >Home</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'module', params: {} }">
        Module
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :to="{ name: 'moduleEdit', params: { id: id } }">
        Edit Module
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-card>
      <v-card-title>Edit Module</v-card-title>
      <v-card-text>
        <module-form :id="id"></module-form>
      </v-card-text>
    </v-card>
  </div>
</template>

    <script>
import ModuleForm from "./ModuleForm.vue";

export default {
  name: "module",
  data() {
    return {
      id: null,
    };
  },
  components: {
    ModuleForm,
  },
  created() {
    this.id = this.$route.params.id;
    this.$emit("showParent", false);
  },
};
</script>
    